import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import OrderProp from '../../propTypes/orderProp';
import PayOrderAddress from './PayOrderAddress';
import MondialRelay from '../../../../commonComponents/modialRelay/MondialRelay';
import organizationProp from '../../../../commonComponents/propTypes/organizationProp';
import AddressProp from '../../../../commonComponents/propTypes/addressProp';
import CountryProp from '../../../../commonComponents/forms/Address/CountryProp';
import FocusWrapper from '../../../../commonComponents/FocusWrapper';

const PayOrderShippingTab = forwardRef((props, ref) => {
  const {
    t,
    order,
    organization,
    pickupLocation,
    onPickupLocation,
    countries,
    isMondialRelay,
    showMondialRelay,
  } = props;
  const {
    shippingAddress,
    shipping: shippingProvider,
    billingAddress,
    installationAddress,
  } = order;

  const refWrapper = useRef();
  const customerKey =
    organization?.services?.mondial_relay?.config?.customerCode || null;

  const handlePickupPoint = pickupId => {
    onPickupLocation({
      ...pickupId,
      country:
        countries.find(c => c.code === pickupId?.countryCode)?.name ||
        pickupId?.countryCode,
    });
  };

  useImperativeHandle(ref, () => ({
    focusMondialRelay() {
      refWrapper.current.focusWithTimeout();
    },
  }));

  return (
    <>
      <div className="m-portlet shop-order-blocks">
        <div className="m-portlet__body m-portlet__body--no-padding">
          <div className="m-invoice-2">
            <PayOrderAddress
              id="0"
              label={t('shop.cart.billing')}
              address={billingAddress}
              formatAddress
            />
            <PayOrderAddress
              id="1"
              label={t('shop.cart.shipping')}
              address={shippingAddress}
              formatAddress
            />
            {!!installationAddress && (
              <PayOrderAddress
                id="2"
                label={t('order_detail_right.installationAddress')}
                address={installationAddress}
                formatAddress
              />
            )}
            {!!shippingProvider && (
              <PayOrderAddress
                id="2"
                label={t('academy.sessions.makeOrder.shippingProvider')}
                shippingProvider={shippingProvider}
                isProvider
              />
            )}
            {!!pickupLocation?.address_1 && (
              <PayOrderAddress
                id="3"
                label={t('shop.pickupLocation')}
                address={pickupLocation}
                formatAddress
                isPickupLocation
              />
            )}
          </div>
        </div>
      </div>
      {!!(isMondialRelay && showMondialRelay) && (
        <div className="m-portlet shop-order-blocks">
          <div className="m-portlet__body m-portlet__body--no-padding">
            <div className="m-invoice-2">
              <FocusWrapper ref={refWrapper}>
                <div className="m-invoice-2 products-toPay shipping-toPayContainer mondial_relayFocus">
                  <h3 className="products-toPay-title">
                    {t('shop.cart.pickupLocation')}
                  </h3>
                  <div className="mondial-relayWidget">
                    <MondialRelay
                      onPickupSelection={handlePickupPoint}
                      config={{
                        Country: shippingAddress?.countryCode?.toUpperCase(),
                        AllowedCountries: [
                          shippingAddress?.countryCode?.toUpperCase(),
                        ],
                        PostCode: shippingAddress?.zipCode,
                        Brand: customerKey,
                      }}
                    />
                  </div>
                </div>
              </FocusWrapper>
            </div>
          </div>
        </div>
      )}
    </>
  );
});

PayOrderShippingTab.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  organization: PropTypes.shape(organizationProp.propType).isRequired,
  pickupLocation: PropTypes.shape(AddressProp.propType),
  onPickupLocation: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  isMondialRelay: PropTypes.bool.isRequired,
  showMondialRelay: PropTypes.bool,
};

PayOrderShippingTab.defaultProps = {
  pickupLocation: null,
  showMondialRelay: false,
};

export default PayOrderShippingTab;
